module.exports = __webpack_public_path__ + "static/media/nuestroblog_platodelbiencomer.47a040a6.png";